
// Qingming Festival (清明節) themed logo
// Original logo shape traced and redesigned with spring/Qingming atmosphere
// Inspired by the poem: 清明時節雨紛紛
import Vue from 'vue'

const SEARCH_URL = 'https://www.google.com/search?q=%E6%B8%85%E6%98%8E%E7%AF%80'

const logoPath =
  'M 154 82 C 154 82.1 153.8 113 156 126 C 157.9 137 160.8 146 165 156' +
  ' C 169.6 167 176.7 179 183 188 C 188.1 195.2 194.6 207 199 206' +
  ' C 204.6 205 205 171 211 169 C 215 167.5 220.3 176 226 178' +
  ' C 232.7 181 241.6 183 249 184 C 255.6 185 261.4 185 268 184' +
  ' C 275.6 183 286 174 292 177 C 298.4 180 306.7 197 304 203' +
  ' C 301 209.4 281.2 211 271 212 C 262.4 213 254.3 213 247 212' +
  ' C 240.8 211 235.2 206 230 208 C 221.4 212 216.6 249 208 251' +
  ' C 201.7 252.4 193.8 241 187 235 C 179.7 228.5 172.3 221 166 213' +
  ' C 160 205.6 154.8 198.2 150 190 C 145.1 181.5 140.4 163 137 163' +
  ' C 133.2 163.4 130.2 187 129 199 C 127.9 211 128.4 224 130 235' +
  ' C 131.5 246 134 256 138 266 C 142.4 278 158.5 293 156 301' +
  ' C 153.9 308 137.7 317 131 315 C 123.8 313 119.4 296 115 286' +
  ' C 110.7 276 107.5 267 105 256 C 102.3 244 100.5 230 100 219' +
  ' C 99.5 210 99.9 202 101 193 C 102.3 182 104.8 170 108 159' +
  ' C 110.9 149 114.5 140 119 131 C 123.7 121.5 129.9 111 136 103' +
  ' C 141.6 95.2 154 82 154 82 Z'

export default Vue.extend({
  name: 'QingmingLogo',
  data() {
    return {
      SEARCH_URL,
      logoPath
    }
  }
})
